import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept-drug";

export const getConceptDrugById = conceptDrugId => axios.get(API_PATH + "/get-by-id/"+ conceptDrugId);

export const pagingConceptDrug = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const saveConceptDrug = conceptDrug => axios.post(API_PATH + '/save', conceptDrug);

export const deleteConceptDrug = conceptDrugId => axios.delete(API_PATH + '/mark-delete/' + conceptDrugId);
